/*
 * Customer Favorites API client.
 *
 * QR menü kullanıcısının favori yemekleri (ürünleri).
 *   GET    /api/customer/favorites?restaurant_id=X   → listele
 *   POST   /api/customer/favorites/{stockId}         → ekle (idempotent)
 *   DELETE /api/customer/favorites/{stockId}         → sil  (idempotent)
 *   POST   /api/customer/favorites/{stockId}/toggle  → toggle, yeni state döner
 *
 * Auth: Bearer customer Sanctum token (customerClient interceptor ekler).
 */

import { customerClient } from './customerAuth';

export interface CustomerFavoriteRestaurant {
  id: number;
  name?: string | null;
  logo?: string | null;
}

export interface CustomerFavoriteStock {
  stock_id: number;
  name: string;
  image: string | null;
  price: number;
  restaurant?: CustomerFavoriteRestaurant | null;
  // Backend bonus alanları (kategori, açıklama vs.) — esnek tutuyoruz.
  [extra: string]: any;
}

export interface CustomerFavoritesListResponse {
  data?: CustomerFavoriteStock[];
  favorites?: CustomerFavoriteStock[];
  // Bazı backend versiyonları doğrudan diziyle dönüyor.
}

export interface CustomerFavoriteToggleResponse {
  is_favorited: boolean;
  stock_id: number;
}

const normalizeListResponse = (data: any): CustomerFavoriteStock[] => {
  if (Array.isArray(data)) return data as CustomerFavoriteStock[];
  if (Array.isArray(data?.data)) return data.data as CustomerFavoriteStock[];
  if (Array.isArray(data?.favorites)) return data.favorites as CustomerFavoriteStock[];
  return [];
};

/** Müşterinin tüm favori stoklarını çek. `restaurantId` verilirse sadece
 *  o restorandakiler döner (QR menüde "burdakı favoritlerim" için). */
export async function getCustomerFavorites(
  restaurantId?: number | null,
  signal?: AbortSignal,
): Promise<CustomerFavoriteStock[]> {
  const params: Record<string, any> = {};
  if (restaurantId && Number.isFinite(restaurantId)) {
    params.restaurant_id = restaurantId;
  }
  const res = await customerClient.get('/customer/favorites', { params, signal });
  return normalizeListResponse(res.data);
}

/** Idempotent — iki kez çağrı aynı satırı döner, hata yok. */
export async function addCustomerFavorite(stockId: number): Promise<void> {
  await customerClient.post(`/customer/favorites/${stockId}`);
}

/** Idempotent — favoride yoksa bile 200 dönüyor. */
export async function removeCustomerFavorite(stockId: number): Promise<void> {
  await customerClient.delete(`/customer/favorites/${stockId}`);
}

/** Toggle — kalp ikonunda en pratiği. Yeni state'i döner. */
export async function toggleCustomerFavorite(
  stockId: number,
): Promise<CustomerFavoriteToggleResponse> {
  const res = await customerClient.post<CustomerFavoriteToggleResponse>(
    `/customer/favorites/${stockId}/toggle`,
  );
  return res.data;
}
